// otp/OtpService.js

export const generateOtp = () => {
  return Math.floor(100000 + Math.random() * 900000).toString();
};

export const isOtpValid = (generatedAt, validityMinutes = 5) => {
  const now = Date.now();
  const diff = now - generatedAt;
  return diff < validityMinutes * 60 * 1000;
};
